<section class="progress-section vw-100">
  <div class="progress-container">
    <div class="progress-header d-flex align-items-center justify-content-between">
      <h2 class="progress-title fts-20 font-bold-dali m-0 pr-16">
        Tu progreso en el programa (para el {{ currentYear + 1 }})
      </h2>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <img src="assets/image/modal/close-modal.svg" alt="alert" width="16px" />
      </button>
    </div>

    <div class="progress-content" *ngIf="!loadingSummary && !errorSummary">
      <section class="show-desktop-tablet">
        <div class="progress-bar-container mb-24">
          <mat-progress-bar class="custom-progress-bar" [mode]="'determinate'" [value]="mockProgressData.avatarPosition"
            [color]="'primary'">
          </mat-progress-bar>
          <div class="progress-avatar" [style.left.%]="getAvatarPosition()">
            <div class="progress-status-above-avatar" [style.left.%]="mockProgressData.avatarPosition"
              [ngClass]="alignmentClass">
              <div class="progress-label fts-14 font-bold-dali" [ngClass]="
                  saleData?.actualState?.case != 2
                    ? 'color-support-positive-medium'
                    : 'color-negative-alert'
                ">
                Facturación hasta hoy:
              </div>
              <div class="progress-amount fts-14 font-bold-dali" [ngClass]="
                  saleData?.actualState?.case != 2
                    ? 'color-support-positive-medium'
                    : 'color-negative-alert'
                ">
                S/ {{ mockProgressData.currentAmount | number : "1.0-2" }}
              </div>
            </div>
            <img src="/assets/image/partners-ali/icon-people.svg" alt="Avatar progreso" class="avatar-image" />
          </div>
        </div>

        <div class="progress-levels d-flex justify-content-between mb-32">
          <div class="level-item text-start d-flex">
            <div class="ta-s">
              <img src="/assets/image/partners-ali/icon-badge-bronce.svg" alt="Bronce" class="level-icon" />
              <p class="level-name fts-14 font-bold-dali color-title-custom m-0 mt-8">
                Aliado Bronce
              </p>
              <p class="level-amount fts-12 font-regular color-title-custom m-0">
                Nivel inicial
              </p>
              <p class="m-0 pt-0 pl-0 pr-0 color-support-positive-medium font-bold-italic fts-12"
                *ngIf="saleData?.actualLevelName == 'Bronce'">
                ¡Ve por más!
              </p>
            </div>
          </div>

          <div class="level-item ta-c">
            <img src="/assets/image/partners-ali/icon-badge-plata.svg" alt="Plata" class="level-icon" />
            <p class="level-name fts-14 font-bold-dali color-title-custom m-0 mt-8">
              Aliado Plata
            </p>
            <p class="level-amount fts-12 font-regular color-title-custom m-0">
              S/&nbsp;
              {{
              formatTotalNumber(saleData?.customerSaleLevels[1]?.targetAmount)
              }}
            </p>
            <p *ngIf="getLevelMessageStrict('Plata') as message"
              class="m-0 pt-0 pl-0 pr-0 color-support-positive-medium font-bold-italic fts-12">
              {{ message }}
            </p>

            <div class="tooltip" *ngIf="shouldShowTooltip('silver')" [ngClass]="getTooltipPositionClass('silver')">
              <span class="tooltip-text">Te faltan S/
                {{ getRemainingForLevel("silver") | number : "1.0-2" }} para
                alcanzar este nivel.</span>
            </div>
          </div>

          <div class="level-item ta-c position-relative">
            <img src="/assets/image/partners-ali/icon-badge-oro.svg" alt="Oro" class="level-icon" />
            <p class="level-name fts-14 font-bold-dali color-title-custom m-0 mt-8">
              Aliado Oro
            </p>
            <p class="level-amount fts-12 font-regular color-title-custom m-0">
              S/&nbsp;
              {{
              formatTotalNumber(saleData?.customerSaleLevels[2]?.targetAmount)
              }}
            </p>
            <p *ngIf="getLevelMessageStrict('Oro') as message"
              class="m-0 pt-0 pl-0 pr-0 color-support-positive-medium font-bold-italic fts-12">
              {{ message }}
            </p>

            <div class="tooltip" *ngIf="shouldShowTooltip('gold')" [ngClass]="getTooltipPositionClass('gold')">
              <span class="tooltip-text">
                Te faltan <br />
                S/ {{ getRemainingForLevel("gold") | number : "1.0-2" }} para
                alcanzar este nivel.
              </span>
            </div>
          </div>

          <div class="level-item d-flex justify-content-end">
            <div class="ta-r vw-100">
              <img src="/assets/image/partners-ali/icon-badge-diamond.svg" alt="Diamante" class="level-icon" />
              <p class="level-name fts-14 font-bold-dali color-title-custom m-0 mt-8">
                Aliado Diamante
              </p>
              <p class="level-amount fts-12 font-regular color-title-custom m-0">
                S/&nbsp;
                {{
                formatTotalNumber(
                saleData?.customerSaleLevels[3]?.targetAmount
                )
                }}
              </p>
              <p *ngIf="getLevelMessageStrict('Diamante') as message"
                class="m-0 pt-0 pl-0 pr-0 color-support-positive-medium font-bold-italic fts-12">
                {{ message }}
              </p>

              <div class="tooltip" *ngIf="shouldShowTooltip('diamond')" [ngClass]="getTooltipPositionClass('diamond')">
                <span class="tooltip-text">Te faltan<br />S/
                  {{ getRemainingForLevel("diamond") | number : "1.0-2" }} para
                  alcanzar este nivel.</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="show-mobile mb-16">
        <p-carousel #carouselGeneralALI [value]="cards" [numVisible]="1" [numScroll]="1" [circular]="false"
          [showNavigators]="false" [showIndicators]="false" styleClass="custom-carousel-ALI">
          <!-- Plantilla de cada ítem del carrusel -->
          <ng-template pTemplate="item" let-card>
            <div class="dinamic-card">
              <ng-container [ngSwitch]="card.id">
                <div class="progress-bar-container mb-24">
                  <mat-progress-bar class="custom-progress-bar" mode="determinate"
                    [value]="getLocalProgress(card.id, false)" color="primary"></mat-progress-bar>
                  <ng-container *ngIf="shouldShowAvatar(card.id)">
                    <div class="progress-avatar" [style.left.%]="getLocalProgress(card.id, true)" #avatarElement>
                      <div class="progress-status-above-avatar" [style.left.%]="getLocalProgress(card.id, false)"
                        [ngClass]="alignmentClassmobile(card.id)">
                        <div class="progress-label fts-14 font-bold-dali" [ngClass]="
                            saleData?.actualState?.case != 2
                              ? 'color-support-positive-medium'
                              : 'color-negative-alert'
                          ">
                          Facturación hasta hoy:
                        </div>
                        <div class="progress-amount fts-14 font-bold-dali" [ngClass]="
                            saleData?.actualState?.case != 2
                              ? 'color-support-positive-medium'
                              : 'color-negative-alert'
                          ">
                          S/
                          {{
                          mockProgressData.currentAmount | number : "1.0-2"
                          }}
                        </div>
                      </div>
                      <img src="/assets/image/partners-ali/icon-people.svg" alt="Avatar progreso"
                        class="avatar-image" />
                    </div>
                  </ng-container>
                  <!-- Card 1 -->
                  <div *ngSwitchCase="1" class="progress-levels-mobile d-flex justify-content-between mt-16">
                    <div class="level-item text-start d-flex">
                      <div class="ta-s">
                        <img src="/assets/image/partners-ali/icon-badge-bronce.svg" alt="Bronce" class="level-icon" />
                        <p class="level-name fts-14 font-bold-dali color-title-custom m-0 mt-8">
                          Aliado Bronce
                        </p>
                        <p class="level-amount fts-12 font-regular color-title-custom m-0">
                          Nivel inicial
                        </p>
                        <p class="m-0 pt-0 pl-0 pr-0 color-support-positive-medium font-bold-italic fts-12"
                          *ngIf="saleData?.actualLevelName == 'Bronce'">
                          ¡Ve por más!
                        </p>
                      </div>
                    </div>
                    <div class="level-item ta-r" [ngClass]="{ 'fade-card': hasEntered }">
                      <img src="/assets/image/partners-ali/icon-badge-plata.svg" alt="Plata" class="level-icon" />
                      <p class="level-name fts-14 font-bold-dali color-title-custom m-0 mt-8">
                        Aliado Plata
                      </p>
                      <p class="level-amount fts-12 font-regular color-title-custom m-0">
                        S/&nbsp;
                        {{
                        formatTotalNumber(
                        saleData?.customerSaleLevels[1]?.targetAmount
                        )
                        }}
                      </p>
                      <p *ngIf="getLevelMessageStrict('Plata') as message"
                        class="m-0 pt-0 pl-0 pr-0 color-support-positive-medium font-bold-italic fts-12">
                        {{ message }}
                      </p>
                      <div class="tooltip" *ngIf="shouldShowTooltip('silver')"
                        [ngClass]="getTooltipPositionClass('diamond')">
                        <span class="tooltip-text">
                          Te faltan<br />S/
                          {{
                          getRemainingForLevel("silver") | number : "1.0-2"
                          }}
                          para alcanzar este nivel.
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- Card 2 -->
                  <div *ngSwitchCase="2" class="progress-levels-mobile d-flex justify-content-between mt-16">
                    <div class="level-item text-start d-flex">
                      <div class="ta-s">
                        <img src="/assets/image/partners-ali/icon-badge-plata.svg" alt="Plata" class="level-icon" />
                        <p class="level-name fts-14 font-bold-dali color-title-custom m-0 mt-8">
                          Aliado Plata
                        </p>
                        <p class="level-amount fts-12 font-regular color-title-custom m-0">
                          S/&nbsp;
                          {{
                          formatTotalNumber(
                          saleData?.customerSaleLevels[1]?.targetAmount
                          )
                          }}
                        </p>
                        <p *ngIf="getLevelMessageStrict('Plata') as message"
                          class="m-0 pt-0 pl-0 pr-0 color-support-positive-medium font-bold-italic fts-12">
                          {{ message }}
                        </p>

                        <div class="tooltip" *ngIf="shouldShowTooltip('silver')"
                          [ngClass]="getTooltipPositionClass('bronze')">
                          <span class="tooltip-text">
                            Te faltan<br />S/
                            {{
                            getRemainingForLevel("silver") | number : "1.0-2"
                            }}
                            para alcanzar este nivel.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="level-item ta-r position-relative" [ngClass]="{ 'fade-card': hasEntered2 }">
                      <img src="/assets/image/partners-ali/icon-badge-oro.svg" alt="Oro" class="level-icon" />
                      <p class="level-name fts-14 font-bold-dali color-title-custom m-0 mt-8">
                        Aliado Oro
                      </p>
                      <p class="level-amount fts-12 font-regular color-title-custom m-0">
                        S/&nbsp;
                        {{
                        formatTotalNumber(
                        saleData?.customerSaleLevels[2]?.targetAmount
                        )
                        }}
                      </p>
                      <p *ngIf="getLevelMessageStrict('Oro') as message"
                        class="m-0 pt-0 pl-0 pr-0 color-support-positive-medium font-bold-italic fts-12">
                        {{ message }}
                      </p>

                      <div class="tooltip" *ngIf="shouldShowTooltip('gold')"
                        [ngClass]="getTooltipPositionClass('diamond')">
                        <span class="tooltip-text">Te faltan <br />S/
                          {{
                          getRemainingForLevel("gold") | number : "1.0-2"
                          }}
                          para alcanzar este nivel.</span>
                      </div>
                    </div>
                  </div>
                  <!-- Card 3 -->
                  <div *ngSwitchCase="3" class="progress-levels-mobile d-flex justify-content-between mt-16">
                    <div class="level-item text-start d-flex">
                      <div class="ta-s">
                        <img src="/assets/image/partners-ali/icon-badge-oro.svg" alt="Oro" class="level-icon" />
                        <p class="level-name fts-14 font-bold-dali color-title-custom m-0 mt-8">
                          Aliado Oro
                        </p>
                        <p class="level-amount fts-12 font-regular color-title-custom m-0">
                          S/&nbsp;
                          {{
                          formatTotalNumber(
                          saleData?.customerSaleLevels[2]?.targetAmount
                          )
                          }}
                        </p>
                        <p *ngIf="getLevelMessageStrict('Oro') as message"
                          class="m-0 pt-0 pl-0 pr-0 color-support-positive-medium font-bold-italic fts-12">
                          {{ message }}
                        </p>
                        <div class="tooltip" *ngIf="shouldShowTooltip('gold')"
                          [ngClass]="getTooltipPositionClass('bronze')">
                          <span class="tooltip-text">Te faltan<br />S/
                            {{
                            getRemainingForLevel("gold") | number : "1.0-2"
                            }}
                            para alcanzar este nivel.</span>
                        </div>
                      </div>
                    </div>
                    <div class="level-item d-flex justify-content-end">
                      <div class="ta-r vw-100">
                        <img src="/assets/image/partners-ali/icon-badge-diamond.svg" alt="Diamante"
                          class="level-icon" />
                        <p class="level-name fts-14 font-bold-dali color-title-custom m-0 mt-8">
                          Aliado Diamante
                        </p>
                        <p class="level-amount fts-12 font-regular color-title-custom m-0">
                          S/&nbsp;
                          {{
                          formatTotalNumber(
                          saleData?.customerSaleLevels[3]?.targetAmount
                          )
                          }}
                        </p>
                        <p *ngIf="getLevelMessageStrict('Diamante') as message"
                          class="m-0 pt-0 pl-0 pr-0 color-support-positive-medium font-bold-italic fts-12">
                          {{ message }}
                        </p>

                        <div class="tooltip" *ngIf="shouldShowTooltip('diamond')"
                          [ngClass]="getTooltipPositionClass('diamond')">
                          <span class="tooltip-text">Te faltan<br />S/
                            {{
                            getRemainingForLevel("diamond") | number : "1.0-2"
                            }}
                            para alcanzar este nivel.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-template>
          <!-- Plantilla para el pie del carrusel (navegación) -->
          <ng-template pTemplate="footer">
            <div class="custom-carousel-nav vw-100 d-flex justify-content-between">
              <button type="button" class="custom-nav-button" (click)="prevPage()"
                [class.disabled]="carouselGeneralALI?.page === 0" [disabled]="carouselGeneralALI?.page === 0">
                <img src="assets/image/essentials/arrow-left.svg" alt="previous" />
              </button>

              <div class="custom-indicators d-sm-flex">
                <button *ngFor="let _ of getTotalPages(); let i = index" type="button" class="custom-indicator"
                  [class.active]="carouselGeneralALI.page === i" (click)="goToPage(i)"></button>
              </div>

              <button type="button" class="custom-nav-button" (click)="nextPage()" [class.disabled]="
                  carouselGeneralALI.page === getTotalPages().length - 1
                " [disabled]="
                  carouselGeneralALI.page === getTotalPages().length - 1
                ">
                <img src="assets/image/essentials/arrow-right.svg" alt="next" />
              </button>
            </div>
          </ng-template>
        </p-carousel>
      </section>
      <div class="dl-divider"></div>
      <!-- esto se reutiliza apra ambas pantallas -->
      <div class="achievements-section">
        <div class="achievements-grid d-flex justify-content-between">
          <div class="achievements-section">
            <div>
              <h4 class="achievement-title fts-16 font-bold-dali color-title-custom mb-0 mt-0">
                Lo que has logrado y lo que puedes alcanzar
              </h4>
            </div>

            <div class="achievements-grid d-flex justify-content-between grid-65-35 mt-24">
              <section class="table-wrapper scroll-hidden" *ngIf="billingData.length">
                <div class="container-border-line scroll-hidden">
                  <!-- Cabecera fija -->
                  <div class="title-table d-flex justify-content-start align-items-center pl-16 pr-16">
                    <p class="p-0 m-0 fts-14 font-bold-dali color-title-custom">
                      Facturación mensual ({{ currentYear }})
                    </p>
                  </div>
                  <hr class="dividing-line-solid m-0" />
                  <!-- Contenido con scroll -->
                  <div class="table-scrollable">
                    <!-- Encabezados fijos -->
                    <div class="d-flex justify-content-between p-16 header-table-awards row">
                      <div class="cell-box fts-14 font-bold-dali color-title-custom col-3"
                        *ngFor="let trimestre of billingData">
                        Trimestre {{ trimestre.trimestre }}
                      </div>
                    </div>
                    <!-- Fila 1 -->
                    <div class="d-flex justify-content-between pv-12 ph-16 row">
                      <div class="cell-box fts-12 font-bold-dali color-title-custom col-3"
                        *ngFor="let trimestre of billingData">
                        <div class="columns-table align-items-center vw-100">
                          <span>{{ trimestre.months[0].name }}</span>
                          <div class="font-regular fts-12">
                            <span *ngIf="trimestre.months[0].amount !== '-'">S/&nbsp;</span>
                            {{ formatTotalNumber(trimestre.months[0].amount) }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Fila 2 -->
                    <div class="d-flex justify-content-between pv-12 ph-16 row">
                      <div class="cell-box fts-12 font-bold-dali color-title-custom col-3"
                        *ngFor="let trimestre of billingData">
                        <div class="columns-table align-items-center vw-100">
                          <div>{{ trimestre.months[1].name }}</div>
                          <div class="font-regular fts-12">
                            <span *ngIf="trimestre.months[1].amount !== '-'">S/&nbsp;</span>
                            {{ formatTotalNumber(trimestre.months[1].amount) }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Fila 3 -->
                    <div class="d-flex justify-content-between pv-12 ph-16 row">
                      <div class="cell-box fts-12 font-bold-dali color-title-custom col-3"
                        *ngFor="let trimestre of billingData">
                        <div class="columns-table align-items-center vw-100">
                          <div>{{ trimestre.months[2].name }}</div>
                          <div class="font-regular fts-12">
                            <span *ngIf="trimestre.months[2].amount !== '-'">S/&nbsp;</span>
                            {{ formatTotalNumber(trimestre.months[2].amount) }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Totales por trimestre -->
                    <div class="d-flex justify-content-between align-items-center p-16 row">
                      <div class="cell-box fts-14 font-bold-dali color-title-custom col-3"
                        *ngFor="let trimestre of billingData">
                        <div class="columns-table align-items-center vw-100 line-height-12">
                          <div class="font-bold-dali fts-12">Total</div>
                          <div class="font-bold-dali fts-12"
                            [ngClass]="((saleData?.actualState?.case) !=2)?'color-support-positive-medium':'color-title-custom'">
                            <span *ngIf="formatTotal(trimestre.total) !== '-'">S/&nbsp;</span>
                            {{ formatTotal(trimestre.total) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Footer fijo -->
                  <div class="dividing-line-solid m-0 "></div>
                  <div class="d-flex justify-content-between align-items-center pl-16 pr-16 footer-table"
                    [ngClass]="((saleData?.actualState?.case) !=2)?'title-table-green':'title-table-red'">
                    <div class="font-bold-dali fts-14 d-flex align-items-center color-title-custom">
                      Total acumulado
                    </div>
                    <div
                      [ngClass]="((saleData?.actualState?.case) !=2)?'color-support-positive-medium':'color-negative-alert'"
                      class="font-bold-dali fts-14">
                      &nbsp;S/&nbsp;{{ formatTotalNumber(totalAcumulado.toFixed(2)) }}
                    </div>
                  </div>
                </div>
              </section>
              <section>
                <div class="achievement-card-middle" *ngIf="saleData?.actualState?.case != 6">
                  <div class="achievement-content-horizontal vw-100">
                    <div class="achievement-left"
                      [ngClass]="(saleData?.actualState?.case) !=6?'achievement-left-6':'achievement-left-default'">
                      <div class="achievement-content-left d-flex justify-content-between align-items-center">
                        <div class="achievement-text-content">
                          <h4
                            class="achievement-title fts-14 font-bold-dali color-title-custom mt-0 mb-8 ml-0 mr-0 text-nowrap">
                            ¡Alcanza el nivel Aliado {{ saleData?.customerActualLevel?.nextLevelName }}!
                          </h4>
                          <div class="achievement-details d-flex justify-content-between"
                            *ngIf="saleData?.actualState?.case == 6">
                            <div class="achievement-detail-column">
                              <p class="ta-s fts-12 font-regular color-title-custom mt-8 mb-0  p-0">
                                Tu esfuerzo constante ha dado frutos. Has llegado a la cima y disfrutarás los mejores
                                beneficios durante todo el próximo año.
                              </p>
                            </div>
                          </div>
                          <div class="achievement-details d-flex justify-content-between"
                            *ngIf="saleData?.actualState?.case != 6">
                            <div class="achievement-detail-column">
                              <p class="achievement-text fts-12 font-regular color-title-custom m-0 mb-4">
                                Te faltan:
                              </p>
                              <p class="achievement-value fts-14 font-bold-dali color-title-custom m-0">
                                <span *ngIf="saleData?.customerActualLevel?.amountToNext< 0">-</span>S/ {{
                                Math.abs(saleData?.customerActualLevel?.amountToNext) | number:'1.2-2' }}
                              </p>
                            </div>
                            <div class="achievement-detail-column ta-c">
                              <p class="achievement-text fts-12 font-regular color-title-custom m-0 mb-4">
                                Alcanzado:
                              </p>
                              <p class="achievement-value fts-14 font-bold-dali color-title-custom m-0">
                                {{ saleData?.customerActualLevel?.progressPercentage | number:'1.0-0' }}%
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="achievement-medal-right">
                          <img [src]="getNextLevelMedal(saleData?.customerActualLevel?.nextLevelName)" alt="Medalla"
                            class="achievement-icon" width="40px" />
                        </div>
                      </div>
                    </div>
                    <div class="dl-divider mt-16 mb-16" *ngIf="saleData?.actualState?.case != 6"></div>
                    <div class="achievement-right" *ngIf="saleData?.actualState?.case != 6">
                      <div class="achievement-header d-flex align-items-center mb-8">
                        <h5 class="achievement-subtitle fts-12 font-regular color-title-custom m-0">
                          Promedio mensual para ser
                          Aliado {{ saleData?.customerActualLevel?.nextLevelName }} (hasta fin de año)
                        </h5>
                      </div>
                      <div class="achievement-details">
                        <p class="achievement-text fts-14 font-regular color-title-custom m-0">
                          <span *ngIf="getMonthlyAverageRequired() < 0">-</span><span
                            class="font-bold-dali color-title-custom">S/ {{ Math.abs(getMonthlyAverageRequired()) |
                            number:'1.2-2' }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div [ngClass]="[
    achievementCardMiddle(saleData?.actualState?.case),
    saleData?.actualState?.case !== 6 ? 'achievement-card-large mt-16' : 'achievement-left-6'
  ]">
                  <div class="achievement-content-large d-flex align-items-center p-16">
                    <div class="achievement-text-content-large"
                      [ngClass]=" saleData?.actualState?.case !== 6 ? 'ta-s' : 'ta-c'">
                      <section *ngIf=" saleData?.actualState?.case == 6">
                        <div class="achievement-focus-right">
                          <img src="/assets/image/partners-ali/{{activeCaseData?.icon}}.svg" alt="Foco"
                            class="achievement-icon-large mb-16" width="60px" />
                        </div>
                      </section>
                      <h4 class="achievement-title font-bold-dali color-title-custom m-0 mb-8 line-height-16"
                        [ngClass]="saleData?.actualState?.case == 6?'fts-16':'fts-14'">
                        {{activeCaseData?.title}}
                      </h4>
                      <div class="achievement-details mt-8">
                        <p class="achievement-text fts-12 font-regular color-title-custom m-0 line-height-12">
                          {{activeCaseData?.description}} </p>
                      </div>
                    </div>
                    <section *ngIf=" saleData?.actualState?.case !== 6">
                      <div class="achievement-focus-right">
                        <img src="/assets/image/partners-ali/{{activeCaseData?.icon}}.svg" alt="Foco"
                          class="achievement-icon-large" width="40px" />
                      </div>
                    </section>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>

        <div class="progress-footer mt-24">
          <p class="footer-text fts-12 font-regular color-title-custom m-0 ta-s">
            La reevaluación se realizará en enero del {{ currentYear + 1 }}, se tiene en consideración la venta
            acumulada de enero a diciembre de {{ currentYear }}. La venta está calculada con el Importe Real
            Facturado. Categorías no consideradas: panetones, chocolates de taza y socios comerciales.
          </p>
        </div>
      </div>
    </div>
    <!-- Tu progreso en el programa -->

    <ng-container *ngIf="loadingSummary">
      <allies-progress-modal-skeleton [currentYear]="currentYear"
        [mockProgressData]="mockProgressData"></allies-progress-modal-skeleton>
    </ng-container>
    <ng-container *ngIf="!loadingSummary && errorSummary">
      <section class="error-offerBy-cods p-24 mt-16">
        <div class=" d-flex justify-content-center pv-48">
          <div class="message-allies-progress">
            <app-message-empty-error [messageError]="messageAlliesProgressError"
              (retryDataError)="obtenerResumenDeFacturacion()">
            </app-message-empty-error>
          </div>
        </div>
      </section>
    </ng-container>
    <!-- end Tu progreso en el programa -->
  </div>
</section>